import type { Actions, Subjects } from '../features/authorization/types/permissions.types'

export enum AppRoutes {
    // Public routes - Authentication
    LOGIN = '/auth/login',
    SIGNUP = '/auth/signup',
    FORGOT_PASSWORD = '/auth/forgot-password',
    RESET_PASSWORD = '/auth/reset-password',
    VERIFY_EMAIL = '/auth/verify-email',
    COMPLETE = '/auth/complete',
    SETUP = '/auth/setup',
    SIGNIN = '/auth/signin',
    INVITE = '/auth/invite',
    MAGIC_LINK_SENT = '/auth/magic-link-sent',
    MAGIC_LINK_EXPIRED = '/auth/magic-link-expired',
    // Impersonation exchange route
    IMPERSONATE = '/impersonate',

    // Intake survey routes
    INTAKE_SURVEY = '/intake-survey/:token',
    INTAKE_SURVEY_EXPIRED = '/intake-survey/survey-expired',

    // Private routes - Core app
    DASHBOARD = '/dashboard',
    PROFILE = '/profile',
    NOTIFICATION_SETTINGS = '/notification-settings',

    // Team routes
    TEAM = '/team',

    // Unified Upload routes (NEW SCHEMA)
    UPLOAD = '/upload',
    UPLOAD_HRIS = '/upload/hris-upload',
    UPLOAD_PERFORMANCE = '/upload/performance-upload',
    UPLOAD_DOCUMENT = '/upload/document-upload',
    UPLOAD_DETAILS = '/upload/:jobId',

    // Employee specific routes
    LEARN = '/learn',
    LEARN_SECTION = '/learn/:section_name',
    CAREER = '/career',
    BRAG = '/brag',

    // HR and shared routes
    PEOPLE = '/people',
    CONNECT = '/connect',
    DOCUMENTATION = '/documentation',
    ALERTS = '/alerts',
    SURVEYS = '/surveys',
    KUDOS = '/kudos',
    REPORTS = '/reports',

    // HR Intake routes (simplified schema)
    HR_INTAKE = '/intake',

    // Employee detail route
    TEAM_MEMBER_DETAIL = '/team/:employeeId',
    PEOPLE_DETAIL = '/people/:uuid',

    // Error routes
    FORBIDDEN = '/403',
    NOT_FOUND = '/404',
    ERROR = '/error',

    // Internal/debug routes (not linked in UI)
    SENTRY_TEST = '/__sentry-test',
}

export enum LayoutType {
    AUTH = 'auth',
    APP = 'app',
    MINIMAL = 'minimal',
    PROTECTED_MINIMAL = 'protected_minimal',
}

export interface RouteConfig {
    path: AppRoutes
    component: React.ComponentType
    layout: LayoutType
    requireAuth?: boolean
    requireOrganization?: boolean
    allowedRoles?: string[]
    requiredPermission?: {
        action: Actions
        subject: Subjects
    }
    title?: string
    description?: string
}

export type RouteGuardProps = {
    children: React.ReactNode
    requireAuth?: boolean
    requireOrganization?: boolean
    allowedRoles?: string[]
    requiredPermission?: {
        action: Actions
        subject: Subjects
    }
}
